module.exports = __webpack_public_path__ + "img/coupon_tutorial_bepiu02.11756dc9.png";